import ResizeObserver from 'resize-observer-polyfill';

function fillCanvasBG(){

    console.log("BG");

	let gyro = false;
	window.addEventListener("devicemotion", function(event){
		if(event.rotationRate.alpha || event.rotationRate.beta || event.rotationRate.gamma)
			gyro = true;
	});

	const canvasContainer = document.getElementById('canvas-container');

	let margin = 75;
	let levels = 4;
	let perc_min = [10, 25, 45, 70];
	let perc_max = [30, 55, 75, 90];

	let accx, accy;

	let objectSizes;

	let globalX, globalY, default_perc, ssx, ssy;
	let source;
	let tiles = [];

	let lines_left = [];
	let lines_right = [];

	let lines_up = [];
	let lines_down = [];

	let lines_x = [];
	let lines_y = [];

	let easing = 0.075;

    let filename = document.querySelector('[js-hook-script]').getAttribute('data-file');

	let sketch = function(p) {

		p.preload = function() {
			source = p.loadImage("assets/images/"+filename);
			objectSizes = getObjectSizes(canvasContainer);
			canvasObserver.observe(canvasContainer);
		}

		p.setup = function() {

			p.createCanvas(objectSizes.width, objectSizes.height);
			p.rectMode(p.CORNER);

			ssx = source.width/(levels*2+2);
			ssy = source.height/(levels*2+2);

			for(let i = 0; i < levels*2+2; i++){
				tiles[i] = [];
				for(let j = 0; j < levels*2+2; j++){
					let x = Math.ceil(j*ssx);
					let y = Math.ceil(i*ssy);
					tiles[i][j] = source.get(x, y, ssx, ssy);
				}
            }

			for(let i = 0; i < levels; i++){
				lines_left[i] = 0;
				lines_right[i] = 0;
				lines_up[i] = 0;
				lines_down[i] = 0;
			}

			for(let i = 0; i < levels*2+2; i++){
				lines_x[i] = 0;
				lines_y[i] = 0;
			}


			p.noStroke();

			default_perc = 100/(levels+1);

			globalX = objectSizes.width/2;
			globalY = objectSizes.height/2;

			p.frameRate(60);

		}

		p.draw = function() {
            p.clear();

			if(gyro){
				if(accx != undefined){
					globalX = globalX+accx*2;
				}

				if(accy != undefined){
					globalY = globalY-accy*2;
				}
			} else {
				let targetX = p.mouseX;
				let dx = targetX - globalX;
				globalX += dx * easing;

				let targetY = p.mouseY;
				let dy = targetY - globalY;
				globalY += dy * easing;
			}

			if(globalY < margin) globalY = margin;
			if(globalX < margin) globalX = margin;
			if(globalY > objectSizes.height-margin) globalY = objectSizes.height-margin;
			if(globalX > objectSizes.width-margin) globalX = objectSizes.width-margin;

			let xvalue = p.map(globalX, margin, objectSizes.width-margin, -1, 1);

			if (xvalue <= 0) {
				for (let i = 0; i < lines_left.length; i++) {
					let perc = p.map(xvalue, -1, 0, perc_min[i], default_perc*(i+1));
					lines_left[i] = (globalX/100)*perc;
					lines_right[i] = globalX+((objectSizes.width-globalX)/100)*perc;
				}
			} else {
				for (let i = 0; i < lines_left.length; i++) {
					let perc = p.map(xvalue, 0, 1, default_perc*(i+1), perc_max[i]);
					lines_left[i] = (globalX/100)*perc;
					lines_right[i] = globalX+((objectSizes.width-globalX)/100)*perc;
				}
			}

			let yvalue = p.map(globalY, margin, objectSizes.height-margin, -1, 1);

			if (yvalue <= 0) {
				for (let i = 0; i < levels; i++) {
					let perc = p.map(yvalue, -1, 0, perc_min[i], default_perc*(i+1));
					lines_up[i] = (globalY/100)*perc;
					lines_down[i] = globalY+((objectSizes.height-globalY)/100)*perc;
				}
			} else {
				for (let i = 0; i < levels; i++) {
					let perc = p.map(yvalue, 0, 1, default_perc*(i+1), perc_max[i]);
					lines_up[i] = (globalY/100)*perc;
					lines_down[i] = globalY+((objectSizes.height-globalY)/100)*perc;
				}
			}

			lines_x[0] = 0;
			lines_y[0] = 0;

			for(let i = 0; i < levels; i++){
				lines_x[i+1] = lines_left[i];
				lines_y[i+1] = lines_up[i];
			}

			lines_x[levels+1] = globalX;
			lines_y[levels+1] = globalY;

			for(let i = levels+2; i < lines_x.length; i++){
				lines_x[i] = lines_right[i-levels-2];
				lines_y[i] = lines_down[i-levels-2];
            }

			for(let i = 0; i <= lines_y.length-1; i++){
				for(let j = 0; j <= lines_x.length-1; j++){
					if(j == lines_x.length-1 || i == lines_y.length-1){
						if(j == lines_x.length-1 && i != lines_y.length-1){
							p.image(tiles[i][j], lines_x[j], lines_y[i], objectSizes.width-lines_x[j]+1, lines_y[i+1]-lines_y[i]+1);
						} else if(j != lines_x.length-1 && i == lines_y.length-1){
							p.image(tiles[i][j], lines_x[j], lines_y[i], lines_x[j+1]-lines_x[j]+1, objectSizes.height-lines_y[i]+1);
						} else {
							p.image(tiles[i][j], lines_x[j], lines_y[i], objectSizes.width-lines_x[j]+1, objectSizes.height-lines_y[i]+1);
						}
					} else {
						p.image(tiles[i][j], lines_x[j], lines_y[i], lines_x[j+1]-lines_x[j]+1, lines_y[i+1]-lines_y[i]+1);
					}
				}
            }

		}

		const canvasObserver = new ResizeObserver(entries => {
			objectSizes.width = entries[0].contentRect.width;
			objectSizes.height = entries[0].contentRect.height;
			p.resizeCanvas(objectSizes.width, objectSizes.height);
		});

		window.addEventListener('devicemotion', function(e) {
			// get accelerometer values
			accx = parseInt(e.accelerationIncludingGravity.x);
			accy = parseInt(e.accelerationIncludingGravity.y);
			accy += 3;
		});
	}

	new p5(sketch, canvasContainer);
}

function getObjectSizes(element){
	const { width, height } = element.getBoundingClientRect();
	return { width, height };
}

export default fillCanvasBG;


// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/demo.test/frontend/source/utilities/bg_canvas.js